



// 



import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { ApiService } from '../../services/api.service';
import { MatDialog } from '@angular/material';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/user.model';
import { Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { CaseManagementService } from '../../services/case-management.service';

@Component({
    selector: 'cases-management',
    template: require('./cases-management.component.html'),
    styles: [require('./cases-management.component.css')],
    animations: [fadeInOut]
})
export class CasesComponent {
    searchText: string;
    isGettingCases = false;
    memberDetailsParams: any = {};
    cases: any = [];
    allCases: any[] = [];
    currentUser: User;
    isSearching = false;
    unknownCases = [];
    knownCases = [];
    loadingIndicator: boolean = false;
    caseByManager: any[];

    filteredCases : Observable<any[]>;

    private subject: Subject<string> = new Subject();
    myControl: FormControl = new FormControl();

    constructor(private router: Router, private apiService: ApiService, private authService: AuthService, private caseManagementService : CaseManagementService,
        public dialog: MatDialog, private alertService: AlertService) {
        this.currentUser = this.authService.currentUser;
        console.log(this.currentUser)
        this.subject.debounceTime(1).subscribe(searchTextValue => {
            this.searchCases();
        });

        this.getUnknownCases();
        this.getKnownCases();
        this.getCaseByCaseManager();
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }

    goCaseManagement(row) {
        console.log(row)
        this.router.navigate(['/case-management', row.caseNum])
    }
    getCaseByCaseManager() {
        this.loadingIndicator = true;
        this.caseManagementService.getAllOpenCaseDashboard().subscribe(r => {
            var caseArr = r.map(i => i.caseNum);
            this.caseByManager = r;
            this.caseManagementService.getLastNotes(caseArr).subscribe(res => {
                r.forEach(i => {
                    i.cmNote = res.find(e => e.caseNum == i.caseNum);
                })
                
                this.loadingIndicator = false;
                console.log(this.caseByManager)
            })
            
        })
    }

    /** Bound to the refresh control in the header. */
    onRefreshCase() {
        this.loadCases();
    }

    private loadCases() {
        this.apiService.umapSearchCases("").subscribe(r => {
            this.allCases = r;
        })
    }

    ngOnInit() {

        this.loadCases();

        this.filteredCases = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(val => this.filter(val))
            );
    }

    filter(val: string): any[] {
        if (!val) {
            return this.allCases;
        }
        const filterVal = val.toLowerCase();

        return this.allCases.filter(option =>
           
            option.cmMember.firstName.toLowerCase().includes(filterVal)
            ||
            option.cmMember.lastName.toLowerCase().includes(filterVal)
            ||
            (option.cmMember.firstName.toLowerCase() + " " + option.cmMember.lastName.toLowerCase()).includes(filterVal)
            ||
            option.caseNum.toLowerCase().includes(filterVal)
        );
    }


    getUnknownCases() {
        this.apiService.umapGetUnknownCases().subscribe(r =>
        {
            this.unknownCases = r;
        });
    }

    getKnownCases() {
        this.apiService.umapGetKnownCases().subscribe(r => {
            this.knownCases = r;
        });
    }


    onKeyUp(searchTextValue: string) {
        this.subject.next(searchTextValue);


    }

    searchCases() {
        if (this.searchText.length < 2) return;
        this.isGettingCases = true;
        this.apiService.umapSearchCases(this.searchText).subscribe(r => {
            this.cases = r;
            this.isGettingCases = false;
        }, err => {
            this.isGettingCases = false;
            this.alertService.showMessage(err.error, "", MessageSeverity.error);
        });
    }

    createEditCase(member: any) {
        //let dialogRef = this.dialog.open(CreateEditCaseModalComponent, {
        //    width: '600px',
        //    data: {
        //        currentCase: member || {},
        //        vendors: this.members
        //    }
        //});

        //dialogRef.afterClosed().subscribe(r => {
        //    this.getCases();
        //})
    }

    deleteCase(memberId: number) {
        //this.alertService.showDialog("Do you want to delete this Case ?", DialogType.confirm, val => {

        //    this.apiService.deleteCase(memberId).subscribe(r => {
        //        this.getCases();
        //    });
        //});
    }

    onActivate(event) {
        if (event.type === 'click') {
          
            //let dialogRef = this.dialog.open(CaseDetailDialogComponent, {
            //    panelClass: "col-md-9",
            //    data: {
            //        member: event.row
            //    }
            //});

            //dialogRef.afterClosed().subscribe(r => {
            //    //this.getCases();
            //})

            this.router.navigateByUrl("/case-management/" + event.row.caseNum)
        }
        
    }

    assignCase(cmNote) {
        this.apiService.umapAssignCase(cmNote.noteId, cmNote).subscribe(r => {
            this.alertService.showMessage("", "Assign Case successfully", MessageSeverity.success);
            this.getUnknownCases();
            this.getKnownCases();
        });
    }

    fetchInboundDocs() {
        this.apiService.umapFetchInboundDocs().subscribe(r => {
            this.alertService.showMessage("fetched successfully!", "", MessageSeverity.success);
            this.getUnknownCases();
            this.getKnownCases();
        })
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/cases-management/cases-management.component.ts